import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from './common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { 
  FiArrowRight, 
  FiArrowLeft, 
  FiCheckCircle, 
  FiUser, 
  FiBriefcase, 
  FiHeart, 
  FiDollarSign, 
  FiTrendingUp,
  FiClock,
  FiShield,
  FiTarget,
  FiPlay,
  FiCheck,
  FiInfo,
  FiFileText,
  FiMail,
  FiPhone,
  FiMapPin
} = FiIcons;

function App() {
  const [testStarted, setTestStarted] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showResult, setShowResult] = useState(false);
  const [showImprint, setShowImprint] = useState(false);

  // Fragenkatalog mit Bereichen und Punkten
  const questions = [
    // Bereich 1: Ausbildung & berufliche Erfahrung
    {
      id: 1,
      category: "Ausbildung & berufliche Erfahrung",
      icon: FiBriefcase,
      question: "Entspricht Ihre berufliche Vorbildung oder praktische Erfahrung der Branche, in der Sie gründen möchten?",
      options: [
        { text: "Ja, vollständig passend", points: 2 },
        { text: "Teilweise passend", points: 1 },
        { text: "Nein, passt gar nicht", points: 0 }
      ]
    },
    {
      id: 2,
      category: "Ausbildung & berufliche Erfahrung",
      icon: FiBriefcase,
      question: "Haben Sie bereits Erfahrung darin gesammelt, Mitarbeiter anzuleiten oder deren Arbeit zu koordinieren?",
      options: [
        { text: "Mehrere Jahre Erfahrung", points: 2 },
        { text: "Bis zu zwei Jahre Erfahrung", points: 1 },
        { text: "Keine Führungserfahrung", points: 0 }
      ]
    },
    {
      id: 3,
      category: "Ausbildung & berufliche Erfahrung",
      icon: FiBriefcase,
      question: "Verfügen Sie über kaufmännisches oder betriebswirtschaftliches Wissen oder entsprechende praktische Kenntnisse?",
      options: [
        { text: "Umfangreiche Qualifikation vorhanden", points: 2 },
        { text: "Solide Grundqualifikation vorhanden", points: 1 },
        { text: "Keine nennenswerten Kenntnisse", points: 0 }
      ]
    },
    {
      id: 4,
      category: "Ausbildung & berufliche Erfahrung",
      icon: FiBriefcase,
      question: "Welche Erfahrungen haben Sie im Vertrieb gesammelt?",
      options: [
        { text: "Mehrjährige Vertriebserfahrung", points: 2 },
        { text: "Bis zu zwei Jahre Erfahrung", points: 1 },
        { text: "Keine oder sehr geringe Vertriebserfahrung", points: 0 }
      ]
    },
    // Bereich 2: Belastbarkeit & persönliches Engagement
    {
      id: 5,
      category: "Belastbarkeit & persönliches Engagement",
      icon: FiHeart,
      question: "Wären Sie bereit, besonders in der Anfangsphase wöchentlich 60 Stunden oder mehr zu arbeiten?",
      options: [
        { text: "Ja, jederzeit", points: 2 },
        { text: "Unter bestimmten Bedingungen", points: 1 },
        { text: "Nein, das kommt nicht infrage", points: 0 }
      ]
    },
    {
      id: 6,
      category: "Belastbarkeit & persönliches Engagement",
      icon: FiHeart,
      question: "Würde Ihre Familie oder Ihr direkter privater Rückhalt Ihr Gründungsvorhaben unterstützen?",
      options: [
        { text: "Ja, definitiv", points: 2 },
        { text: "Vielleicht / teilweise", points: 1 },
        { text: "Nein, eher nicht", points: 0 }
      ]
    },
    {
      id: 7,
      category: "Belastbarkeit & persönliches Engagement",
      icon: FiHeart,
      question: "Könnten Sie damit leben, zunächst kein regelmäßiges oder sicheres Einkommen zu haben?",
      options: [
        { text: "Ja, damit komme ich klar", points: 2 },
        { text: "Unter Umständen ja", points: 1 },
        { text: "Nein, das wäre problematisch", points: 0 }
      ]
    },
    // Bereich 3: Gesundheit & Arbeitsweise
    {
      id: 8,
      category: "Gesundheit & Arbeitsweise",
      icon: FiUser,
      question: "Wie war Ihre körperliche Verfassung in den letzten drei Jahren?",
      options: [
        { text: "Fast nie krank", points: 2 },
        { text: "Gelegentliche kleinere Erkrankungen", points: 1 },
        { text: "Häufig oder längerfristig krank", points: 0 }
      ]
    },
    {
      id: 9,
      category: "Gesundheit & Arbeitsweise",
      icon: FiUser,
      question: "Können Sie auch über längere Zeit mit Stress umgehen und Herausforderungen aktiv angehen?",
      options: [
        { text: "Meistens gut", points: 2 },
        { text: "Eher ja", points: 1 },
        { text: "Nur eingeschränkt", points: 0 }
      ]
    },
    {
      id: 10,
      category: "Gesundheit & Arbeitsweise",
      icon: FiUser,
      question: "Sind Sie es gewohnt, sich Ziele zu setzen und diese eigenständig zu verfolgen, ohne äußeren Druck?",
      options: [
        { text: "Sehr häufig", points: 2 },
        { text: "Gelegentlich", points: 1 },
        { text: "Selten", points: 0 }
      ]
    },
    // Bereich 4: Finanzielle Voraussetzungen
    {
      id: 11,
      category: "Finanzielle Voraussetzungen",
      icon: FiDollarSign,
      question: "Verfügen Sie über finanzielle Rücklagen, um die Gründung notfalls selbst zu finanzieren?",
      options: [
        { text: "Ja, ausreichend", points: 2 },
        { text: "Ja, mit gewissen Einschränkungen", points: 1 },
        { text: "Nein, keine Reserven", points: 0 }
      ]
    },
    {
      id: 12,
      category: "Finanzielle Voraussetzungen",
      icon: FiDollarSign,
      question: "Gibt es in Ihrem Haushalt zusätzliche stabile Einkommensquellen (Partner/in, andere Einnahmen)?",
      options: [
        { text: "Ja, zuverlässig vorhanden", points: 2 },
        { text: "Teilweise vorhanden", points: 1 },
        { text: "Nein, keine vorhanden", points: 0 }
      ]
    },
    // Bereich 5: Risiko & persönliche Lage
    {
      id: 13,
      category: "Risiko & persönliche Lage",
      icon: FiTrendingUp,
      question: "Wie beurteilen Sie Ihre beruflichen Entwicklungschancen im bisherigen Job?",
      options: [
        { text: "Eher weniger gut", points: 2 },
        { text: "Durchschnittlich", points: 1 },
        { text: "Sehr gut", points: 0 }
      ]
    },
    {
      id: 14,
      category: "Risiko & persönliche Lage",
      icon: FiTrendingUp,
      question: "Wie würden Sie mit den Unsicherheiten einer selbstständigen Tätigkeit umgehen?",
      options: [
        { text: "Ich sehe keinen Anlass zur Sorge", points: 2 },
        { text: "Ich kann damit leben", points: 1 },
        { text: "Ich wäre eher unsicher", points: 0 }
      ]
    },
    {
      id: 15,
      category: "Risiko & persönliche Lage",
      icon: FiTrendingUp,
      question: "Wie steht Ihr Partner bzw. Ihr persönliches Umfeld zu Ihrer Gründungsabsicht?",
      options: [
        { text: "Unterstützt mich uneingeschränkt", points: 2 },
        { text: "Ich bin Single / keine feste Beziehung", points: 1.5 },
        { text: "Unterstützt mich teilweise", points: 1 },
        { text: "Nicht wirklich unterstützend", points: 0 }
      ]
    }
  ];

  // Antwort auswählen (mit eindeutigen Werten)
  const handleAnswer = (questionId, points) => {
    // Für Frage 15: Wenn 1.5 Punkte ausgewählt, speichere als 1 Punkt für die Berechnung
    const actualPoints = points === 1.5 ? 1 : points;
    setAnswers({ ...answers, [questionId]: actualPoints });
  };

  // Nächste Frage
  const nextQuestion = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setShowResult(true);
    }
  };

  // Vorherige Frage
  const previousQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  // Gesamtpunkte berechnen
  const calculateTotal = () => {
    return Object.values(answers).reduce((sum, points) => sum + points, 0);
  };

  // Interpretation basierend auf Punktzahl
  const getInterpretation = (total) => {
    if (total <= 14) {
      return {
        title: "Noch nicht bereit (0-14 Punkte)",
        text: "Ihre aktuelle persönliche und organisatorische Situation spricht eher gegen eine Unternehmensgründung. Überdenken Sie Alternativen und holen Sie weitere Beratung ein.",
        color: "text-red-600",
        bgColor: "bg-red-50"
      };
    } else if (total <= 20) {
      return {
        title: "Gemischtes Ergebnis (15-20 Punkte)",
        text: "Ihr Ergebnis ist gemischt. Eine klare Tendenz ist nicht erkennbar. Suchen Sie zusätzliche Einschätzungen und besprechen Sie Ihr Vorhaben mit verschiedenen Personen.",
        color: "text-orange-600",
        bgColor: "bg-orange-50"
      };
    } else {
      return {
        title: "Gute Ausgangsbasis (21-30 Punkte)",
        text: "Sie verfügen über eine gute Ausgangsbasis für eine selbstständige Tätigkeit. Motivation und persönliche Voraussetzungen scheinen stimmig zu sein.",
        color: "text-green-600",
        bgColor: "bg-green-50"
      };
    }
  };

  // Test neu starten
  const restartTest = () => {
    setCurrentQuestion(0);
    setAnswers({});
    setShowResult(false);
    // Wir bleiben im "testStarted" Modus, um direkt neu zu beginnen
  };

  // Zurück zur Startseite
  const goToStart = () => {
    setTestStarted(false);
    restartTest();
  };

  const progress = ((currentQuestion + 1) / questions.length) * 100;
  const currentQ = questions[currentQuestion];
  const hasAnswer = answers[currentQ?.id] !== undefined;

  // Footer-Komponente
  const Footer = () => (
    <footer className="bg-gray-100 border-t border-gray-200 py-4 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <button
          onClick={() => setShowImprint(true)}
          className="text-gray-500 hover:text-gray-700 text-sm transition-colors duration-200 flex items-center justify-center mx-auto"
        >
          <SafeIcon icon={FiFileText} className="mr-2" />
          Impressum & Haftung
        </button>
      </div>
    </footer>
  );

  // --- IMPRESSUMSSEITE ---
  if (showImprint) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <button
              onClick={() => setShowImprint(false)}
              className="mb-4 text-blue-600 hover:text-blue-800 font-medium flex items-center transition-colors duration-200"
            >
              <SafeIcon icon={FiArrowLeft} className="mr-2" />
              Zurück zum Test
            </button>
            
            <div className="flex items-center mb-4">
              <SafeIcon icon={FiFileText} className="text-3xl text-blue-600 mr-3" />
              <h1 className="text-3xl font-bold text-gray-800">Impressum / Haftung</h1>
            </div>
          </div>

          {/* Inhalt */}
          <div className="bg-white rounded-xl shadow-lg p-8 space-y-8">
            {/* Unternehmen */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                <SafeIcon icon={FiInfo} className="mr-2 text-blue-600" />
                Unternehmen
              </h2>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-gray-700 leading-relaxed">
                  Internet Consulting Group Inc.<br />
                  304 S. Jones Blvd #3009<br />
                  Las Vegas NV 89107<br />
                  USA
                </p>
              </div>
            </section>

            {/* Kontakt */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                <SafeIcon icon={FiMail} className="mr-2 text-blue-600" />
                Kontakt
              </h2>
              <div className="space-y-2">
                <div className="flex items-center text-gray-700">
                  <SafeIcon icon={FiPhone} className="mr-3 text-gray-400" />
                  <span>Telefon: 1-239-645-4696</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <SafeIcon icon={FiMail} className="mr-3 text-gray-400" />
                  <span>E-Mail: internetconsultinggroup@gmail.com</span>
                </div>
              </div>
            </section>

            {/* Verantwortlich */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                <SafeIcon icon={FiUser} className="mr-2 text-blue-600" />
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-gray-700 leading-relaxed">
                  Internet Consulting Group Inc.<br />
                  304 S. Jones Blvd #3009<br />
                  Las Vegas NV 89107<br />
                  USA
                </p>
              </div>
            </section>

            {/* Haftungsausschluss */}
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                <SafeIcon icon={FiShield} className="mr-2 text-blue-600" />
                Haftungsausschluss
              </h2>
              
              <div className="space-y-6">
                {/* Haftung für Inhalte */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-700 mb-2">Haftung für Inhalte</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                  </p>
                </div>

                {/* Haftung für Links */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-700 mb-2">Haftung für Links</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                  </p>
                </div>

                {/* Urheberrecht */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-700 mb-2">Urheberrecht</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                  </p>
                </div>
              </div>
            </section>
          </div>
          <Footer />
        </div>
      </div>
    );
  }

  // --- STARTSEITE ---
  if (!testStarted) {
    return (
      <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="flex-1 flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-xl shadow-xl max-w-2xl w-full overflow-hidden"
          >
            {/* Header Image / Gradient */}
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-8 text-center text-white">
              <SafeIcon icon={FiTarget} className="text-6xl mx-auto mb-4 text-blue-100" />
              <h1 className="text-3xl font-bold mb-2">Persönlichkeits-Check für Existenzgründer</h1>
              <p className="text-blue-100 text-lg max-w-lg mx-auto">
                Ein Selbstcheck, der Ihre persönlichen, beruflichen und finanziellen Voraussetzungen für eine Unternehmensgründung beleuchtet.
              </p>
            </div>

            <div className="p-8">
              {/* Was wird gemessen */}
              <div className="mb-8">
                <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                  <SafeIcon icon={FiCheckCircle} className="mr-2 text-blue-600" />
                  Was der Test misst:
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {[
                    "Motivation", 
                    "Belastbarkeit", 
                    "Führungserfahrung", 
                    "Finanzielle Voraussetzungen", 
                    "Risikobereitschaft", 
                    "Unterstützung durch Umfeld"
                  ].map((item, i) => (
                    <div key={i} className="flex items-center text-gray-600">
                      <SafeIcon icon={FiCheck} className="mr-2 text-green-500 flex-shrink-0" />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Nutzen */}
              <div className="bg-blue-50 rounded-lg p-5 mb-8 border border-blue-100">
                <h4 className="font-semibold text-blue-800 mb-2">Warum diesen Test machen?</h4>
                <p className="text-blue-700">
                  Hilft Ihnen einzuschätzen, ob Sie für eine selbstständige Tätigkeit vorbereitet sind und welche Bereiche Sie eventuell stärken sollten.
                </p>
              </div>

              {/* Info Footer: Dauer & Datenschutz */}
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center text-sm text-gray-500 mb-8 space-y-3 md:space-y-0">
                <div className="flex items-center">
                  <SafeIcon icon={FiClock} className="mr-2 text-gray-400 text-lg" />
                  <span>Der Test umfasst 15 Fragen und dauert etwa 5–10 Minuten.</span>
                </div>
                <div className="flex items-center">
                  <SafeIcon icon={FiShield} className="mr-2 text-gray-400 text-lg" />
                  <span>Ihre Antworten werden nicht gespeichert und bleiben anonym.</span>
                </div>
              </div>

              {/* Start Button */}
              <button
                onClick={() => setTestStarted(true)}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center text-lg"
              >
                Test starten
                <SafeIcon icon={FiPlay} className="ml-2" />
              </button>
            </div>
          </motion.div>
        </div>
        <Footer />
      </div>
    );
  }

  // --- ERGEBNISSEITE ---
  if (showResult) {
    const total = calculateTotal();
    const interpretation = getInterpretation(total);
    
    return (
      <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="flex-1 flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-xl shadow-xl p-8 max-w-2xl w-full"
          >
            <div className="text-center mb-8">
              <SafeIcon icon={FiCheckCircle} className="text-6xl text-green-500 mx-auto mb-4" />
              <h1 className="text-3xl font-bold text-gray-800 mb-2">Test abgeschlossen!</h1>
              <p className="text-gray-600">Hier ist Ihr Ergebnis:</p>
            </div>

            <div className={`${interpretation.bgColor} rounded-lg p-6 mb-6`}>
              <h2 className={`text-2xl font-bold ${interpretation.color} mb-4`}>
                {interpretation.title}
              </h2>
              <div className="text-center mb-4">
                <span className="text-4xl font-bold text-gray-800">{total}</span>
                <span className="text-lg text-gray-600 ml-2">von 30 Punkten</span>
              </div>
              <p className="text-gray-700 leading-relaxed">{interpretation.text}</p>
            </div>

            {/* Hinweis auf professionellen Test */}
            <div className="bg-blue-50 rounded-lg p-4 mb-6 border border-blue-100">
              <div className="flex items-start">
                <SafeIcon icon={FiPhone} className="text-blue-600 text-xl mr-3 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-blue-800 font-medium mb-1">Professionelle Beratung</p>
                  <p className="text-blue-700 text-sm">
                    Falls Sie einen professionellen, zertifizierten Test durchführen möchten, stehen wir Ihnen gerne zur Verfügung.
                  </p>
                  <p className="text-blue-700 font-semibold mt-2">069-21939559</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={goToStart}
                className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center"
              >
                <SafeIcon icon={FiArrowLeft} className="mr-2" />
                Zur Startseite
              </button>
              <button
                onClick={restartTest}
                className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center"
              >
                Test wiederholen
                <SafeIcon icon={FiArrowRight} className="ml-2" />
              </button>
            </div>
          </motion.div>
        </div>
        <Footer />
      </div>
    );
  }

  // --- FRAGEBOGEN ---
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="bg-white rounded-xl shadow-xl max-w-4xl w-full overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-6 relative">
            <button 
              onClick={goToStart}
              className="absolute top-6 right-6 text-blue-200 hover:text-white transition-colors"
              aria-label="Abbrechen und zur Startseite"
            >
              <SafeIcon icon={FiArrowLeft} className="inline mr-1" /> Start
            </button>
            <h1 className="text-2xl font-bold mb-2 pr-32">Gründer-Persönlichkeits-Test</h1>
            <p className="text-blue-100">Frage {currentQuestion + 1} von {questions.length}</p>
            
            {/* Fortschrittsbalken */}
            <div className="mt-4 bg-blue-500 rounded-full h-2">
              <motion.div
                className="bg-white rounded-full h-2"
                initial={{ width: 0 }}
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.3 }}
              />
            </div>
          </div>

          {/* Frage */}
          <div className="p-8">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentQuestion}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                {/* Kategorie */}
                <div className="flex items-center mb-6">
                  <SafeIcon icon={currentQ.icon} className="text-2xl text-blue-600 mr-3" />
                  <span className="text-sm font-semibold text-blue-600 uppercase tracking-wide">
                    {currentQ.category}
                  </span>
                </div>

                {/* Frage */}
                <h2 className="text-xl font-semibold text-gray-800 mb-8 leading-relaxed">
                  {currentQ.question}
                </h2>

                {/* Antwortoptionen als Radio-Buttons */}
                <div className="space-y-3">
                  <form>
                    {currentQ.options.map((option, index) => (
                      <label
                        key={index}
                        className={`block relative cursor-pointer transition-all duration-200 ${
                          answers[currentQ.id] === (option.points === 1.5 ? 1 : option.points)
                            ? 'bg-blue-50 border-blue-500'
                            : 'hover:bg-gray-50 border-gray-200'
                        }`}
                      >
                        <div className="p-4 rounded-lg border-2 transition-all duration-200">
                          <div className="flex items-center">
                            <input
                              type="radio"
                              name={`question-${currentQ.id}`}
                              value={option.points}
                              checked={answers[currentQ.id] === (option.points === 1.5 ? 1 : option.points)}
                              onChange={() => handleAnswer(currentQ.id, option.points)}
                              className="mr-3 w-5 h-5 text-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            />
                            <span className={`font-medium text-lg ${
                              answers[currentQ.id] === (option.points === 1.5 ? 1 : option.points)
                                ? 'text-blue-800' 
                                : 'text-gray-700'
                            }`}>
                              {option.text}
                            </span>
                          </div>
                        </div>
                      </label>
                    ))}
                  </form>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Navigation */}
          <div className="bg-gray-50 px-8 py-6 flex justify-between items-center">
            <button
              onClick={previousQuestion}
              disabled={currentQuestion === 0}
              className={`flex items-center px-4 py-2 rounded-lg font-medium transition-colors duration-200 ${
                currentQuestion === 0
                  ? 'text-gray-400 cursor-not-allowed'
                  : 'text-gray-600 hover:text-gray-800 hover:bg-gray-200'
              }`}
            >
              <SafeIcon icon={FiArrowLeft} className="mr-2" />
              Zurück
            </button>

            <button
              onClick={nextQuestion}
              disabled={!hasAnswer}
              className={`flex items-center px-6 py-2 rounded-lg font-medium transition-colors duration-200 ${
                hasAnswer
                  ? 'bg-blue-600 hover:bg-blue-700 text-white'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              {currentQuestion === questions.length - 1 ? 'Ergebnis anzeigen' : 'Weiter'}
              <SafeIcon icon={FiArrowRight} className="ml-2" />
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;